import { createBrowserRouter } from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard";
import SignIn from "./pages/signin/signin";
import ErrorPage from "./error-page";
import App from "./App";
import AllOrders from "./pages/orders/all-orders/all-orders";
import OrdersCreated from "./pages/orders/created/created";
import OrdersValidation from "./pages/orders/validation/validation";
import OrdersAssign from "./pages/orders/assign/assign";
import OrdersAccepted from "./pages/orders/accepted/accepted";
import OrdersQCReview from "./pages/orders/qc-review/qc-review";
import OrdersBilling from "./pages/orders/billing/billing";
import OrdersIssues from "./pages/orders/issues/issues";
import OrdersOnHold from "./pages/orders/on-hold/on-hold";
import OrdersClosed from "./pages/orders/closed/closed";
import Users from "./pages/admin/users/users";
import Clients from "./pages/admin/clients/clients";
import Reviewers from "./pages/admin/reviewers/reviewers";
import FormTemplates from "./pages/admin/form-templates/form-templates";
import Map from "./pages/admin/map/map";
import Scorecard from "./pages/admin/scorecard/scorecard";
import Goals from "./pages/admin/goals/goals";
import ReportingTools from "./pages/admin/reporting-tools/reporting-tools";
// import ManageAccount from "./pages/admin/users/manage-account/manage-account";
import ClientDetails from "./pages/admin/clients/client-details/client-details";
import InspectionFirms from "./pages/admin/inspection-firms/inspection-firms";
import InspectionFirmDetails from "./pages/admin/inspection-firms/inspection-firm-details/inspection-firm-details";
import UserDetails from "./pages/admin/users/user-details/user-details";
import MyProfile from "./pages/myprofile/myprofile";
import RolesPermissions from "./pages/admin/roles-permissions/roles-permisions";
import FormTemplateSettings from "./pages/admin/form-templates/settings/settings";
import FormBuilder from "./pages/admin/form-templates/form-builder/form-builder";
import ClientFormSettings from "./pages/admin/clients/client-details/forms/settings/settings";
import OrderDetails from "./pages/orders/order-details/order-details";
import Invoices from "./pages/admin/invoices/invoices";
import ResetPasswordPage from "./pages/reset-password/reset-password";
import ForgotPasswordPage from "./pages/forgot-password/forgot-password";
import InspectionForm from "./pages/orders/inspection-form/inspection-form";
import MFASetUp from "./pages/signin/mfa-setup";
import OTPPage from "./pages/signin/otp";
import MyOrganization from "./pages/admin/my-organization/my-organization";
import OrdersInProgress from "./pages/orders/in-progress/in-progress";
import OrdersSubmitted from "./pages/orders/submitted/submitted";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "users/:username",
        element: <UserDetails />,
      },
      {
        path: "clients",
        element: <Clients />,
      },
      {
        path: "clients/:clientId",
        element: <ClientDetails />,
      },
      {
        path: "clients/:clientId/users",
        element: <ClientDetails />,
      },
      {
        path: "clients/:clientId/users/:userId",
        element: <UserDetails />,
      },
      {
        path: "clients/:clientId/forms",
        element: <ClientDetails />,
      },
      {
        path: "clients/:clientId/forms/:formName",
        element: <ClientFormSettings />,
      },
      {
        path: "clients/:clientId/orders",
        element: <ClientDetails />,
      },
      {
        path: "clients/:clientId/orders/:orderId",
        element: <OrderDetails />,
      },
      {
        path: "inspection-firms",
        element: <InspectionFirms />,
      },
      {
        path: "inspection-firms/:inspectionFirmId",
        element: <InspectionFirmDetails />,
      },
      {
        path: "inspection-firms/:inspectionFirmId/users",
        element: <InspectionFirmDetails />,
      },
      {
        path: "inspection-firms/:inspectionFirmId/users/:userId",
        element: <UserDetails />,
      },
      {
        path: "inspection-firms/:inspectionFirmId/orders",
        element: <InspectionFirmDetails />,
      },
      {
        path: "inspection-firms/:inspectionFirmId/orders/:orderId",
        element: <OrderDetails />,
      },
      {
        path: "reviewers",
        element: <Reviewers />,
      },
      {
        path: "invoicing",
        element: <Invoices />,
      },
      {
        path: "form-templates",
        element: <FormTemplates />,
      },
      {
        path: "form-templates/:formName",
        element: <FormTemplateSettings />,
      },
      {
        path: "map",
        element: <Map />,
      },
      {
        path: "scorecard",
        element: <Scorecard />,
      },
      {
        path: "goals",
        element: <Goals />,
      },
      {
        path: "reporting-tools",
        element: <ReportingTools />,
      },
      {
        path: "roles-permissions",
        element: <RolesPermissions />,
      },
      {
        path: "all-orders",
        element: <AllOrders />,
      },
      {
        path: "orders/:orderId",
        element: <OrderDetails />,
      },
      {
        path: "created",
        element: <OrdersCreated />,
      },
      {
        path: "validation",
        element: <OrdersValidation />,
      },
      {
        path: "assign",
        element: <OrdersAssign />,
      },
      {
        path: "accepted",
        element: <OrdersAccepted />,
      },
      {
        path: "qc-review",
        element: <OrdersQCReview />,
      },
      {
        path: "in-progress",
        element: <OrdersInProgress />,
      },
      {
        path: "submitted",
        element: <OrdersSubmitted />,
      },
      {
        path: "billing",
        element: <OrdersBilling />,
      },
      {
        path: "issues",
        element: <OrdersIssues />,
      },
      {
        path: "on-hold",
        element: <OrdersOnHold />,
      },
      {
        path: "closed",
        element: <OrdersClosed />,
      },
      {
        path: "/myprofile",
        element: <MyProfile />,
      },
      {
        path: "my-organization",
        element: <MyOrganization />,
      },
      {
        path: "my-organization/users",
        element: <MyOrganization />,
      },
      {
        path: "my-organization/users/:userId",
        element: <UserDetails />,
      },
    ],
  },
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "/mfa-setup",
    element: <MFASetUp />,
  },
  {
    path: "/mfa-otp",
    element: <OTPPage />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPasswordPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "form-templates/:formName/form-builder",
    element: <FormBuilder />,
  },
  {
    path: "clients/:clientId/forms/:formName/form-builder",
    element: <FormBuilder />,
  },
  {
    path: "orders/:orderId/inspection-form",
    element: <InspectionForm />,
  },
]);

export default router;
